<template>
  <div class="login-container">
    <div class="login-box">
      <h2>Welcome</h2>
      <p class="subtitle">
        Please enter your credentials to access the application
      </p>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <label for="email">Email</label>
          <input
            type="email"
            id="email"
            v-model="email"
            required
            placeholder="Enter your email"
          />
        </div>
        <div class="form-group">
          <label for="password">Password</label>
          <div class="input-group">
            <input
              :type="showPassword ? 'text' : 'password'"
              id="password"
              v-model="password"
              required
              placeholder="Enter your password"
            />
            <button
              type="button"
              class="toggle-password"
              @click="togglePasswordVisibility"
            >
              {{ showPassword ? "👁️" : "👁️‍🗨️" }}
            </button>
          </div>
        </div>
        <button type="submit" class="login-button">Log In</button>
      </form>
      <p v-if="error" class="error-message">{{ error }}</p>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      error: "",
      showPassword: false,
    };
  },
  // mounted() {    
  //   auth.onAuthStateChanged(user => {
  //     if (user) {
  //       this.$router.push("/");
  //     }
  //   });
  // },
  methods: {
    async handleLogin() {
      try {
        const userCredential = await auth.signInWithEmailAndPassword(
          this.email,
          this.password
        );
        
        const tokenResult = await userCredential.user.getIdTokenResult();
        const userRole = tokenResult.claims['data-manager-role']; // custom claim

        this.$emit("login-success", userCredential.user, userRole);
        this.$router.push("/");
      } catch (err) {
        console.error("Login error:", err);
        switch (err.code) {
          case "auth/invalid-credential":
            this.error =
              "Invalid credentials provided. Please check your email and password.";
            break;
          case "auth/user-not-found":
            this.error =
              "No account found with this email. Please sign up or try a different email.";
            break;
          case "auth/wrong-password":
            this.error = "Incorrect password. Please try again.";
            break;
          case "auth/too-many-requests":
            this.error =
              "Too many unsuccessful login attempts. Please try again later.";
            break;
          default:
            this.error =
              "An error occurred during login. Please try again later.";
        }
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>

<style scoped>
:root {
  --primary-color: #007bff; /* Example primary color */
  --primary-color-dark: #0056b3; /* Example darker primary color for hover */
}

.login-container {
  display: flex;
  justify-content: center;
  align-items: start;
  padding-top: 100px;
  min-height: 100vh;
  background-color: #f5f5f5;
}

.login-box {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

h2 {
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 1.8rem;
}

.subtitle {
  color: #666;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #555;
  font-weight: bold;
}

.input-group {
  position: relative;
}

input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1.2rem;
}

.login-button {
  width: 100%;
  padding: 0.75rem;
  background-color: var(--primary-color, #007bff); /* Fallback color added */
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.login-button:hover {
  background-color: var(--primary-color-dark, #0056b3);
}

.error-message {
  color: #d32f2f;
  margin-top: 1rem;
  text-align: center;
  font-size: 0.9rem;
}
</style>
